import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { ReviewStars } from 'reusableComponents';
import { getHomepageLogos, getPlaceNotesCount } from 'services/homePage.services';

const Partners = () => {
  const [t] = useTranslation('global');
  const [logos, setLogos] = useState([]);
  const [loading, setLoading] = useState(true);
    const [placeNotesCount, setPlaceNotesCount] = useState(null);
  const [error, setError] = useState(false);

useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // Fetch logos and companies count in parallel
        const [logosData, countData] = await Promise.all([
          getHomepageLogos(t('i18nextLng') || 'fr'),
          getPlaceNotesCount(t('i18nextLng') || 'fr')
        ]);
        
        setLogos(logosData || []);
        
        // Extract the count from the API response
        let count = 0;
        if (typeof countData === 'number') {
          count = countData;
        } else if (countData && countData.count) {
          count = countData.count;
        } else if (countData && countData.data) {
          count = countData.data;
        }
        setPlaceNotesCount(count);
        
        setError(false);
      } catch (e) {
        console.error('Error fetching data:', e);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [t]);

  const renderLogo = (logo) => {
    if (!logo.logo_url) {
      return (
        <div className={styles.logoTextFallback}>
          {logo.name?.slice(0, 2).toUpperCase() || 'LO'}
        </div>
      );
    }

    return (
      <img
        src={logo.logo_url}
        alt={logo.name || 'Partner logo'}
        className={styles.logoImage}
        loading="lazy"
        onError={(e) => {
          if (logo.thumb_logo_url) {
            e.currentTarget.src = logo.thumb_logo_url;
          } else {
            e.currentTarget.style.display = 'none';
          }
        }}
      />
    );
  };

  const renderHeader = () => (
    <>
      <div className={styles.reviewContainer}>
        <p className={styles.reviewText}>
          {t('home.partnersAverageReview')}
        </p>
        <ReviewStars rating={10} />
      </div>
      <p
        className={styles.sectionText}
        dangerouslySetInnerHTML={{ __html: t('home.partnersText', { count: placeNotesCount }) }}
      />
    </>
  );

  if (loading) {
    return (
      <section className={`mediumContainer ${styles.partners}`}>
        <div className={styles.container}>
          {renderHeader()}
          <div className={styles.loadingContainer}>
            <div className={styles.loadingSpinner} />
            <p className={styles.loadingText}>Chargement des logos…</p>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className={`mediumContainer ${styles.partners}`}>
        <div className={styles.container}>
          {renderHeader()}
          <p className={styles.errorText}>
            Impossible de charger les logos.
          </p>
        </div>
      </section>
    );
  }

  if (!logos.length) {
    return (
      <section className={`mediumContainer ${styles.partners}`}>
        <div className={styles.container}>
          {renderHeader()}
          <p className={styles.noLogosText}>
            Aucun logo partenaire disponible.
          </p>
        </div>
      </section>
    );
  }

  const shouldDuplicate = logos.length >= 3;

  return (
    <section className={`mediumContainer ${styles.partners}`}>
      <div className={styles.container}>
        {renderHeader()}

        <div className={styles.partnersContainer}>
          <div className={styles.partnersScroller}>
            <div className={styles.partnersGroup}>
              {logos.map((logo) => (
                <div
                  key={logo.id}
                  className={styles.partnerLogo}
                  title={logo.name}
                >
                  {renderLogo(logo)}
                </div>
              ))}
            </div>

            {shouldDuplicate && (
              <div
                className={styles.partnersGroup}
                aria-hidden="true"
              >
                {logos.map((logo) => (
                  <div
                    key={`dup-${logo.id}`}
                    className={styles.partnerLogo}
                    aria-hidden="true"
                  >
                    {renderLogo(logo)}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
